'use strict';
var base = require('./product/base');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * Generates an HTML string representing a price discount to be used in the product
 * tile. The discount is calculated as a percentage of the difference between the
 * list price and sales price of the provided price object.
 *
 * @param {Object} price - An object with 'list' and 'sales' properties for the
 * @param {Object} wrapper - wrapper to be used
 * price of the product.
 */
function updatePriceDiscount(price, wrapper) {
    var discountPercent = Math.round(((price.sales.value - price.list.value) / price.list.value) * 100);
    var $existing = wrapper.find('.price-discount');

    if ($existing.length) {
        // Update only if value has changed
        var $span = $existing.find('.product-tile-prop__discount');
        if ($span.text() !== discountPercent + '%') {
            $span.text(discountPercent + '%');
        }
    } else {
        var html = '<div class="price-discount">' +
                   '<span class="product-tile-prop__discount">' +
                   discountPercent + '%' +
                   '</span>' +
                   '</div>';
        wrapper.prepend(html);
    }
}


/**
 * Applies promotion discounts from a coupon to each item in the cart.
 *
 * Iterates over each item in the provided data object and checks if the item
 * has both 'list' and 'sales' price properties. If these properties are present,
 * it updates the product information display by prepending a calculated price
 * discount to the element with the class 'footer-right' within the product
 * info wrapper identified by the item's UUID.
 *
 * @param {Object} data - The data object containing cart items with pricing information.
 */
function applyPromotionDiscountsFromCoupon(data) {
    data.items.forEach(function (item) {
        var $wrapper = $('.product-info-wrapper.uuid-' + item.UUID).find('.footer-right');

        if (item.price && item.price.list && item.price.sales) {
            updatePriceDiscount(item.price, $wrapper);
        } else {
            // Remove discount if price data is missing or invalid
            $wrapper.find('.price-discount').remove();
        }
    });
}

module.exports = function () {
    $('body').on('submit', '.promo-code-form', function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    base.methods.updateCartTotals(data);
                    applyPromotionDiscountsFromCoupon(data);
                    base.methods.updateApproachingDiscounts(data.approachingDiscounts);
                    base.methods.validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                base.methods.updateCartTotals(data);
                base.methods.updateApproachingDiscounts(data.approachingDiscounts);
                applyPromotionDiscountsFromCoupon(data);
                base.methods.validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
};
